<div class="generic-dialog">
  <h1 class="px-heading-3" mat-dialog-title>{{data.title || 'Confirm'}}</h1>
  <mat-dialog-content>
    <ng-container *ngIf="data.styles">
      <div *ngIf="!data.subtext" [innerHTML]="data.body"></div>
      <div [ngStyle]="data.styles" *ngIf="!data.subtext" [innerHTML]="data.htmlStr"></div>
    </ng-container>
    <ng-container *ngIf="!data.styles">
      <p *ngIf="!data.subtext" [innerHTML]="data.body">
      </p>
    </ng-container>
    <div *ngIf="data.subtext">
      <p style="margin-block-end: 0em">
        {{data.body || ''}}
      </p>
      <p *ngIf="data.subtext!==undefined" style='font-size: 12px; margin-block-end: 0em'
        [innerHTML]="data.subtext || ''">
      </p>
    </div>
  </mat-dialog-content>
  <div mat-dialog-actions *ngIf="!data.reOrderButtons" [ngClass]="{'center-button': data.hasOwnProperty('hideText')}">
    <button class="px-secondary-btn-xs mr-3" [mat-dialog-close]="false"
      *ngIf="!data.hasOwnProperty('hideText')">{{ data.noText || 'No' }}</button>
    <button class="px-primary-btn-xs" [mat-dialog-close]="true">{{ data.yesText || 'Yes' }}</button>
  </div>
  <div mat-dialog-actions *ngIf="data.reOrderButtons">
    <button class="px-primary-btn-xs mr-3" [mat-dialog-close]="true">{{ data.yesText || 'Yes' }}</button>
    <button class="px-secondary-btn-xs" [mat-dialog-close]="false"
      *ngIf="!data.hasOwnProperty('hideText')">{{ data.noText || 'No' }}</button>
  </div>
</div>
